var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-header',{attrs:{"icon":"fa-dot-circle"}}),(_vm.conference.id)?_c('card-body',[_c('webix-scheduler',{attrs:{"conf":_vm.conference}})],1):_vm._e(),_c('card-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }